import React from 'react';
import { withRouter } from 'react-router-dom';
import ConfirmNumberForm from '../../forms/ConfirmNumberForm';

export class ConfirmNumberPage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <ConfirmNumberForm
          initialValues={{
            phoneNumber: '',
            verificationType: 'text'
          }}
        />
      </div>
    );
  }
}

export default withRouter(ConfirmNumberPage);


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmNumberPage/ConfirmNumberPage.jsx